import LoggerState from 'app/enums/LoggerState'

export default function(input){

    switch(input){

        case LoggerState.AVAILABLE: return 'Beschikbaar';
        case LoggerState.DEPLOYED: return 'Ingezet';
        case LoggerState.RETURNING: return 'Retour';
        case LoggerState.REPAIR_PENDING: return 'Behoeft reparatie';
        case LoggerState.REPAIR_ACTIVE: return 'In reparatie';
        case LoggerState.WRITTEN_OF: return 'Afgeschreven';
        default: return '';
    }
}